import $ from 'jquery';

$(function(){

		
	// sort "cropping" of background videos in hero
	$('.hero video').each(function(){
		var $vid = $(this);
		var vidInitTimer = setInterval(function(){
			if($vid[0].readyState >= 3){
				setVideoOrientation();
				clearInterval(vidInitTimer);
			}
		}, 100);
		function setVideoOrientation(){
			var slide_ratio = $('.hero').outerHeight() / $('.hero').outerWidth();
			//console.log(slide_ratio);
			$vid.removeClass('portrait landscape');
			var vid_ratio = $vid.height() / $vid.width();
			if(vid_ratio <= slide_ratio) $vid.addClass('landscape');
			else $vid.addClass('portrait');
		}
		$(window).resize(setVideoOrientation);
	});
	
	

	
	
	
});